import { $ } from '@/Engine/state';
import { Box3 } from 'three';
import { useStoreUI } from '@/Store/storeUI';
import { _raycaster, getPointerCoords } from '@/Engine/eventHandlers/libs/raycaster';

export function isCursorOutsideToolChest() {
    if (!$.selectedModel || !$.toolChest) {
        useStoreUI().isCursorOutsideToolChest = false;
        return false;
    }
    //ИСКЛЮЧЕНИЕ: полоска по середине шкафа дает просвет
    // (как будто вышли за пределы) intersects.length === 0
    if (Math.abs($.pointer.x) < 0.008) return false;

    const intersects = _raycaster.intersectObject($.toolChest._model, false);

    // TODO рефакторинг!
    //момент когда были снаружи шкафа и занесли комплектующее внутрь
    //Правильно инициализируем isLeft (в move не можем инициал, так как ориентируемся на isLeft, как на якорь)
    if (useStoreUI().isCursorOutsideToolChest === true && intersects.length !== 0) {
        $.selectedModel.userData.parent?.isLeft = $.pointer.x < 0;
        $.positionStartPointer = getPointerCoords();
        $.pointerVirtual = $.positionStartPointer?.clone();
        $.selectedModel.userData.parent?.positionStart.copy($.selectedModel.position);
    }
    useStoreUI().isCursorOutsideToolChest = !intersects.length;
    return !intersects.length;
}

export function isModelOutsideToolChest() {
    if (!$.selectedModel || !$.toolChest) return;
    const obj =  $.selectedModel.userData.parent;
    const copy = $.toolChest._model.clone();
    copy.children = [];

    const box: Box3 = new Box3();
    box.makeEmpty();
    box.expandByObject(copy);
    return !obj.obb.intersectsBox3(box);
}